import { parseHostname } from '@ta-interaktiv/parse-hostname'
import {
  updateAge,
  updateEducation,
  updateGender,
  updatePublication
} from 'components/demographics/actions'
import { call, put, select, takeEvery } from 'redux-saga/effects'

import { uploadData } from 'sagas/uploadToFirebase/actions'
import { RootState } from 'stores'
import { Age } from 'types/age'
import { Education } from 'types/education'
import { Gender } from 'types/gender'
import { moveToNextScreen } from '../../sagas/moveToNextScreen'

function* conditionallyMoveToNextScreen() {
  const currentAge: Age = yield select(
    (state: RootState) => state.demographics.age
  )
  const currentGender: Gender = yield select(
    (state: RootState) => state.demographics.gender
  )

  const currentEducation: Education = yield select(
    (state: RootState) => state.demographics.education
  )

  // Both age and gender are set, let's move forward
  if (currentAge && currentGender && currentEducation) {
    yield put(updatePublication(parseHostname().publicationDomain))
    yield put(uploadData())
    yield call(moveToNextScreen)
  }
}

export function* watchForDemographicsActions() {
  yield takeEvery(
    [updateAge.toString(), updateGender.toString(), updateEducation.toString()],
    conditionallyMoveToNextScreen
  )
}
